<!-- eslint-disable max-len -->
<route>
{
  "meta": {
    "requireAdmin": true,
    "customSite": true
  }
}
</route>
<template>
  <div class="py-1">
    <div class="bg-white p-5 shadow m-2">
      <form id="basic" @submit.prevent="createCourse">
        <div class="grid grid-cols-2 items-center mt-5">
          <div>
            <div class="text-3xl font-bold inline-block">Create new course</div>
            <br />
            <div class="text-xl inline-block text-gray-600">Enter course details</div>
          </div>
          <div class="text-right">
            <input type="checkbox" v-model="publish" class="toggle align-middle" />
            <div class="text-lg font-bold inline-block ml-3">Publish</div>
            <button :disabled="description.trim() && title.trim() === ''" type="submit" class="btn btn-primary text-lg ml-3">Save</button>
          </div>
        </div>
        <div class="mt-4">
          <input
            type="text"
            placeholder="Title (required)"
            class="input input-bordered w-full mb-2"
            required
            name="title"
            v-model="title"
          />
          <textarea
            class="textarea h-64 textarea-bordered w-full mb-1"
            placeholder="Description (required)"
            required
            name="description"
            v-model="description"
          />
          <div class="form-control py-3 w-full">
            <div class="text-xl inline-block">Course Type:</div>

            <label class="cursor-pointer label justify-start" style="width: fit-content">
              <input
                type="radio"
                value="mail"
                v-model="Type"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3">Mail</span>
            </label>

            <label class="cursor-pointer label justify-start" style="width: fit-content">
              <input
                type="radio"
                value="twitter"
                v-model="Type"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3">Twitter</span>
            </label>
          </div>
          <div class="form-control">
            <label class="cursor-pointer label justify-start" style="width: fit-content">
              <input
                type="checkbox"
                checked="Charge"
                class="checkbox checkbox-primary"
                v-model="Charge"
              />
              <span class="label-text text-lg ml-3">Charge for the course</span>
            </label>
          </div>
          <input
            type="number"
            v-if="Charge"
            placeholder="Price (required)"
            class="input input-bordered w-95/100 mt-2 ml-5/100 mb-2"
            required
            name="price"
            min="1"
            oninput="validity.valid||(value='');"
            v-model="price"
          />
          <div class="form-control ml-5/100" v-if="Charge">
            <label class="cursor-pointer label justify-start" style="width: fit-content">
              <input
                type="checkbox"
                checked="PPP"
                class="checkbox checkbox-primary"
                v-model="PPP"
              />
              <span class="label-text text-lg ml-3">Use Purchasing Power Parity</span>
            </label>
          </div>
          <div class="form-control">
            <label class="cursor-pointer label justify-start" style="width: fit-content">
              <input
                type="checkbox"
                checked="Limitstudent"
                class="checkbox checkbox-primary"
                v-model="Limitstudent"
              />
              <span class="label-text text-lg ml-3">Limit Students</span>
            </label>
          </div>
          <input
            type="number"
            v-if="Limitstudent"
            placeholder="Max. Students (required)"
            class="input input-bordered w-95/100 mt-2 ml-5/100 mb-2"
            name="maxStudents"
            required
            min="1"
            oninput="validity.valid||(value='');"
            v-model="maxStudents"
          />
          <div class="form-control" >
            <label class="cursor-pointer label justify-start" style="width: fit-content">
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="Threadseries"
              />
              <span class="label-text text-lg ml-3">Create a thread series</span>
            </label>
          </div>
          <div class="form-control" >
            <label class="cursor-pointer label justify-start" style="width: fit-content">
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="Enablehashtag"
              />
              <span class="label-text text-lg ml-3">Enable hashtag submission (premium)</span>
            </label>
          </div>
          <div class="form-control" >
            <label class="cursor-pointer label justify-start" style="width: fit-content">
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="showBackground"
              />
              <span class="label-text text-lg ml-3">Background ( does not work for all settings )</span>
            </label>
          </div>
          <div class="form-control" >
            <label class="cursor-pointer label justify-start" style="width: fit-content">
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="showCheck"
              />
              <span class="label-text text-lg ml-3">Check ( does not work for all settings )</span>
            </label>
          </div>
          <div class="form-control" >
            <label class="cursor-pointer label justify-start" style="width: fit-content">
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="showFeedback"
              />
              <span class="label-text text-lg ml-3">Feedback ( does not work for all settings )</span>
            </label>
          </div>
          <div class="form-control" >
            <label class="cursor-pointer label justify-start" style="width: fit-content">
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="showParticipate"
              />
              <span class="label-text text-lg ml-3">Participate ( does not work for all settings )</span>
            </label>
          </div>
          <div class="form-control" >
            <label class="cursor-pointer label justify-start" style="width: fit-content">
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="showTakeaway"
              />
              <span class="label-text text-lg ml-3">Takeaway ( does not work for all settings )</span>
            </label>
          </div>
          <div class="form-control">
            <label class="cursor-pointer label justify-start" style="width: fit-content">
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="sharingtips"
              />
              <span class="label-text text-lg ml-3">Require Registration for sharing tips</span>
            </label>
          </div>
          <div class="form-control">
            <label class="cursor-pointer label justify-start" style="width: fit-content">
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="AllowsubmissionviaDM"
              />
              <span class="label-text text-lg ml-3">Allow assignment submission via DM </span>
              <span class="label-text text-md ml-3 mt-1">( warn: conversations might be flagged as assignment submissions )</span>
            </label>
          </div>
          <div class="form-control">
            <label class="cursor-pointer label justify-start" style="width: fit-content">
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="linear"
              />
              <span class="label-text text-lg ml-3">Sequential</span>
            </label>
          </div>
          <div class="form-control">
            <label class="cursor-pointer label justify-start" style="width: fit-content">
              <input
                type="checkbox"
                checked="checked"
                class="checkbox checkbox-primary"
                v-model="scheduled"
              />
              <span class="label-text text-lg ml-3">Scheduled</span>
            </label>
          </div>
          <input
            v-if="scheduled"
            type="datetime-local"
            placeholder="Date-Time"
            class="input input-bordered w-95/100 mt-2 ml-5/100 mb-2"
            required
            name="publishDateTime"
            v-model="publishDateTime"
          />
          <div
            v-if="scheduled && hasSubmitted && isNaN(new Date(publishDateTime).getTime())"
            class="text-red-500"
          >
            Please enter valid date time
          </div>
          <select
            v-model="frequency"
            v-if="scheduled"
            class="select select-bordered w-95/100 ml-5/100 mb-2"
            required
          >
            <option disabled="disabled" value="">Choose frequency</option>
            <option value="DAILY">Daily</option>
            <option value="WEEKLY">Weekly</option>
          </select>
          <div v-if="scheduled" class="form-control py-3 w-95/100 ml-5/100">
            <div class="text-xl inline-block">Deliver course on:</div>

            <label v-if="Type === 'twitter'" class="cursor-pointer label justify-start" style="width: fit-content">
              <input
                type="radio"
                value="TWEET"
                v-model="Deliver"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3">via Tweets</span>
            </label>

            <label v-if="Type === 'twitter'" class="cursor-pointer label justify-start" style="width: fit-content">
              <input
                type="radio"
                value="DM"
                v-model="Deliver"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3">via DM</span>
            </label>

            <label v-if="Type === 'twitter'" class="cursor-pointer label justify-start" style="width: fit-content">
              <input
                type="radio"
                value="SITE"
                v-model="Deliver"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3">Site with Twitter Engagement</span>
            </label>

            <label v-if="Type === 'twitter'" class="cursor-pointer label justify-start" style="width: fit-content">
              <input
                type="radio"
                value="SITE-NOTE"
                v-model="Deliver"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3">Site with Twitter Notification</span>
            </label>

            <label
              v-if="Type === 'mail'"
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="radio"
                value="MAIL"
                v-model="Deliver"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3"
                >Site with Mail Engagement</span
              >
            </label>

            <label
              v-if="Type === 'mail'"
              class="cursor-pointer label justify-start"
              style="width: fit-content"
            >
              <input
                type="radio"
                value="MAIL-NOTE"
                v-model="Deliver"
                class="h-4 w-4 text-primaryColor border-indigo-900 border-2"
              />
              <span class="label-text text-lg ml-3"
                >Site with Mail Notification</span
              >
            </label>
          </div>
          <div class="flex">
            <div class="flex-grow">
              <input
                disabled
                type="text"
                placeholder="Image"
                class="input input-bordered w-full mb-2"
                required
                name="img"
                v-model="img"
              />
            </div>
            <div class="flex-none ml-3">
              <input
                ref="selectedFile"
                class="w-full mt-3 text-indigo-700 outline-none bg-gray-100"
                type="file"
                name="selectedFile"
                style="display: none"
                accept="image/jpeg, image/png"
                @change="onImageUpload"
              />
              <button type="button" class="btn btn-outline" @click="$refs.selectedFile.click()">
                Select...
              </button>
            </div>
          </div>
          <div v-if="hasSubmitted && imagePreview === null" class="text-red-500">
            Please select a file
          </div>
          <img width=500 class="pl-2" :src="imagePreview"  alt="" />
          <!--
          <div class="mt-3">
            <button type="submit" class="btn btn-primary ml-3">Save</button>
          </div>
          -->
        </div>
      </form>
    </div>
  </div>
</template>

<script>
// import adminAPI from '@/services/admin';
import axios from 'axios';
import courseAPI from '@/services/course';
import userInfo from '@/services/userInfo';
import store from '@/store';
import utils from '@/services/utils';

export default {
  name: 'topics',
  layout: 'admin',
  store,
  data() {
    return {
      userInfo: [],
      title: '',
      description: '',
      Deliver: 'TWEET',
      price: '',
      maxStudents: '',
      linear: false,
      scheduled: false,
      Charge: false,
      PPP: false,
      publishDateTime: '',
      Limitstudent: false,
      sharingtips: false,
      Enablehashtag: false,
      Threadseries: false,
      showBackground: false,
      showCheck: false,
      showFeedback: false,
      showParticipate: false,
      showTakeaway: false,
      AllowsubmissionviaDM: false,
      frequency: '',
      publish: true,
      Type: 'twitter',
      image: '',
      imagePreview:
        'https://res.cloudinary.com/implicit/image/upload/v1643873624/courses/defaultimage_gtfecl.jpg',
      img: 'defaultimage_gtfecl.jpg',
      hasSubmitted: false,
      creatorId: null,
    };
  },
  computed: {
    user() {
      return store.state.user;
    },
  },
  async mounted() {
    this.creatorId = this.$route.params.coursecreatorId;
    this.userInfo = await userInfo.getUserInfo(this.creatorId);
  },
  methods: {
    onImageUpload(e) {
      if (e.target.files.length > 0) {
        [this.image] = e.target.files;
        const data = URL.createObjectURL(this.image);
        this.img = e.target.files[0].name;
        this.imagePreview = data;
      } else {
        this.img = '';
        this.imagePreview = '';
      }
    },
    async createCourse() {
      this.hasSubmitted = true;
      const publishDateTime = new Date(this.publishDateTime);
      if (
        this.imagePreview !== null &&
        (!this.scheduled || !Number.isNaN(publishDateTime.getTime()))
      ) {
        const cloudName = 'implicit';
        const formData = new FormData();
        formData.append('upload_preset', 'courses');
        formData.append('file', this.image);
        store.commit('toggleLoading', true);
        let payload = {
          title: this.title,
          description: this.description,
          userId: this.userInfo.user.userId,
          price: this.price === '' ? 0 : this.price,
          maxStudents: this.maxStudents,
          linear: this.linear,
          scheduled: this.scheduled,
          publishDateTime: this.scheduled ? publishDateTime.getTime() : new Date().getTime(),
          frequency: this.scheduled ? this.frequency : '',
          publish: this.publish,
          currency: 'USD',
          purchaseParityEnabled: this.PPP,
          medium: this.Deliver,
          setStudentLimit: this.Limitstudent,
          sharingtips: this.sharingtips,
          Enablehashtag: this.Enablehashtag,
          Threadseries: this.Threadseries,
          showBackground: this.showBackground,
          showCheck: this.showCheck,
          showFeedback: this.showFeedback,
          showParticipate: this.showParticipate,
          showTakeaway: this.showTakeaway,
          AllowsubmissionviaDM: this.AllowsubmissionviaDM,
          type: this.Type,
        };
        if (this.image !== '') {
          await axios
            .post(`https://api.cloudinary.com/v1_1/${cloudName}/upload`, formData, {
              transformRequest: (data, headers) => {
                // eslint-disable-next-line no-param-reassign
                delete headers.common.Authorization;
                return data;
              },
            })
            .then((result) => {
              payload = { ...payload, image: result.data.secure_url };
            })
            .catch((e) => console.log(e));
        } else {
          payload = { ...payload, image: this.imagePreview };
        }
        courseAPI
          .createCourse(payload)
          .then(() => {
            store.commit('toggleLoading', false);
            this.$router.push({ path: `/admin/course-creators/${this.creatorId}` });
          })
          .catch((error) => {
            store.commit('toggleLoading', false);
            if (error.response.status === 401) {
              utils.setStatusMsg(this, 'Unauthorized access, redirected to implicit');
              this.$router.push({ path: '/' });
            }
            console.log({ error });
          });
      }
    },
  },
};
</script>

<style>
.top-right {
  top: 1.5rem;
  right: 4rem;
}
</style>
